import { Button, Card } from '@lilith-arcana-os/ui';

import type { AppPage, FeatureFlags, LLMStatus, MemorySummary, UserSession } from '@lilith-arcana-os/domain';

import { PageHeader } from '../components/ui/PageHeader';

interface HomePageProps {
  featureFlags: FeatureFlags;
  llmStatus: LLMStatus;
  memorySummary: MemorySummary;
  onNavigate: (page: AppPage) => void;
  session: UserSession;
}

export function HomePage({
  featureFlags,
  llmStatus,
  memorySummary,
  onNavigate,
  session,
}: HomePageProps) {
  return (
    <div className="space-y-6">
      <PageHeader
        badge={session.isLoggedIn ? 'Sessione attiva' : 'Guest'}
        description="Fondazione WordPress-native con motori separati, cache browser e fallback simbolico sempre disponibile."
        eyebrow="Home"
        title="Ritual command center"
      />

      <Card
        eyebrow="Quick start"
        footer={
          <div className="flex flex-wrap gap-3">
            <Button onClick={() => onNavigate('reading')}>Nuova lettura</Button>
            <Button onClick={() => onNavigate('library')} variant="secondary">
              Biblioteca offline
            </Button>
          </div>
        }
        title="Regola d'oro"
      >
        <p className="text-lg leading-relaxed text-[var(--la-text)]">
          L&apos;LLM non interpreta da zero: riceve sempre carte, orientamenti, posizioni, significati base,
          pattern combinatori, memoria rilevante e mode richiesto.
        </p>
      </Card>

      <div className="grid gap-4 lg:grid-cols-3">
        <Card eyebrow="Provider" title="LLM status">
          <p className="text-sm text-[var(--la-text-muted)]">{llmStatus}</p>
        </Card>
        <Card eyebrow="Feature flags" title="PWA e fallback">
          <p className="text-sm text-[var(--la-text-muted)]">
            PWA: {String(featureFlags.pwaEnabled)} · Hosted: {String(featureFlags.hostedLlmEnabled)} ·
            Symbolic: {String(featureFlags.symbolicFallbackEnabled)}
          </p>
        </Card>
        <Card eyebrow="Memoria" title="Recurring themes">
          <p className="text-sm text-[var(--la-text-muted)]">
            {memorySummary.themes.length > 0
              ? memorySummary.themes.map((theme) => theme.theme).join(', ')
              : 'Ancora nessuna memoria consolidata.'}
          </p>
        </Card>
      </div>
    </div>
  );
}
